import { ReactNode, useContext } from 'react';
import { colors, layout } from './styles';
import { StepShellContext } from './StepShellContext';

interface StepShellProps {
  stepNumber: number;
  totalSteps: number;
  completedSteps: number;
  title: string;
  onBack: () => void;
  onPrevious?: () => void;
  onSaveLater?: () => void;
  onNext?: () => void;
  nextLabel?: string;
  nextDisabled?: boolean;
  children: ReactNode;
}

const StepShell = ({
  stepNumber,
  totalSteps,
  completedSteps,
  title,
  onBack,
  onPrevious,
  onSaveLater,
  onNext,
  nextLabel = 'Next',
  nextDisabled,
  children,
}: StepShellProps) => {
  const { userName } = useContext(StepShellContext);
  const percent = totalSteps > 0 ? Math.round((completedSteps / totalSteps) * 100) : 0;

  return (
    <div style={layout.page}>
      <div style={layout.container}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
          <button type="button" onClick={onBack} style={{ ...layout.back, marginBottom: 0 }}>
            <i className="fas fa-chevron-left" style={{ fontSize: 12, marginRight: 6 }} /> Back to Start
          </button>
          {userName && <div style={{ fontSize: 12, color: colors.muted }}>{userName}</div>}
        </div>

        <div style={{ ...layout.card, padding: 24, marginBottom: 16 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
            <div>
              <div style={{ fontSize: 13, color: colors.muted }}>
                Step {stepNumber} of {totalSteps}
              </div>
              <h2 style={{ ...layout.title, marginTop: 4 }}>{title}</h2>
            </div>
            <div style={{ fontSize: 13, color: colors.muted }}>{percent}% Complete</div>
          </div>
          <div
            style={{
              marginTop: 16,
              background: '#E5E7EB',
              height: 8,
              borderRadius: 99,
              overflow: 'hidden',
            }}
          >
            <div
              style={{
                width: `${percent}%`,
                height: '100%',
                background: colors.primary,
                transition: 'width 0.3s',
              }}
            />
          </div>
        </div>

        <div style={layout.card}>
          {children}
          <hr style={layout.divider} />
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ display: 'flex', gap: 10 }}>
              {onPrevious && (
                <button type="button" onClick={onPrevious} style={layout.secondaryBtn}>
                  <i className="fas fa-chevron-left" /> Previous
                </button>
              )}
              {onSaveLater && (
                <button type="button" onClick={onSaveLater} style={layout.secondaryBtn}>
                  <i className="far fa-save" /> Save for Later
                </button>
              )}
            </div>
            {onNext && (
              <button
                type="button"
                onClick={onNext}
                disabled={nextDisabled}
                style={nextDisabled ? layout.disabledBtn : layout.primaryBtn}
              >
                {nextLabel}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepShell;
